/**
 * Created by Matthew Ary on 12/11/2017.
 */
import state from './state'
import mutations from './mutations'
import getters from './getters'

export default {
  namespaced: true,
  state,
  mutations,
  getters
}
